import {OlivioSpiralLayout} from './olivioSpiralLayout';
import {OlivioLinearLayout} from './olivioLinearLayout';
import {OlivioClusterLayout} from './olivioClusterLayout';
import {OlivioLayout} from './olivioLayout';

const olivioLayouts = {
	spiral: new OlivioSpiralLayout(),
	linear: new OlivioLinearLayout(),
	cluster: new OlivioClusterLayout(),
	none: new OlivioLayout()
};

export {olivioLayouts};

